import UIkit from 'uikit';  // eslint-disable-line
window.UIkit = UIkit;
import { popover }
	from 'popover.js'; // eslint-disable-line
import { throttle }
	from 'throttle.js'; // eslint-disable-line
import { bindEvent }
	from 'utilities.js'; // eslint-disable-line
import { loadAutoplayVideo }
	from 'videos.js'; // eslint-disable-line
// https://github.com/Vestride/Shuffle
import Shuffle from 'shufflejs'; // eslint-disable-line



bindEvent(window, 'load', loadAutoplayVideo);

const popover_target = '#popover-container';
bindEvent(window, 'load', (event) => {
	popover(popover_target);
});

bindEvent(window, 'load', (event) => {
	UIkit.parallax('.wp-block-xd-twotile img', { y: '10vh, -10vh' });
});

jQuery(($ ) => {

	let term = 0, slider;

	const $recipe_slider_content = $('#recipes_slider').clone();

	UIkit.util.on('#recipes-modal', 'hide', function (e) {
		$('html').removeClass('recipes-modal-open');
	});
	UIkit.util.on('#recipes-modal', 'shown', function (e) {
		maybe_hide_scroll_button();
	});



	UIkit.util.on('#recipes_slider', 'beforeitemshow', function (e) {
		const active_slide_index = $(e.target).data('id');
		const $active_slide = $(`#recipes_slider [data-id="${active_slide_index}"]`);
		const $image_slide = $(`#image_slider [data-id="${active_slide_index}"]`);
		$image_slide
			.addClass('active')
			.siblings()
			.removeClass('active');
		a2a.init();
		loadAutoplayVideo(`#image_slider [data-id="${active_slide_index}"] [data-video]`);
	});

	$('.recipes_slider').on('click', '.recipes_slider_next', (e) => {
		e.preventDefault();
		slider.show(slider.index + 1);
	})

	$('.recipes_slider').on('click', '.recipes_modal_close', (e) => {
		e.preventDefault();
		UIkit.modal('#recipes-modal').hide();
		filter($('[href="#all"]'));
	})


	if (!$('#grid').length) {
		return;
	}

	const shuffle = new Shuffle(document.getElementById('grid'), {
		itemSelector: '.recipe',
		speed: 500,
		sizer: '.sizer',

	});

	shuffle.sort({ by: elem => elem.getAttribute('data-number') * 1 });

	const filter = ($elem) => {
		term = $elem.data('term');
		if (!term) {
			term = 0;
		}
		$elem.siblings().removeClass('active');
		$elem.addClass('active');
		shuffle.filter(item => ~$.inArray(term, $(item).data('terms')));


	}

	const maybe_hide_scroll_button = () => {
		const $recipes_slider = $('#recipes_slider');
		const height = $recipes_slider.height();
		const windowHeight = $.windowHeight();
		const windowWidth = $.windowWidth();

		if (windowWidth <= 640) {

			if ((windowHeight + 10) > height) {

				$('.recipe_dialog nav').removeAttr('style');
			} else {
				$('#recipe-scroll-down-button').show();
				$('.recipe_dialog nav').css({ 'padding-right': '3rem' });
			}

		}

	}

	$('#recipes-modal').on('scroll', function (e) {
		$('#recipe-scroll-down-button').hide();
		$('.recipe_dialog nav').removeAttr('style');
	})

	$(document).on('click', '#recipe-scroll-down-button', e => {
		e.preventDefault();
		const $recipes_slider = $('#recipes_slider');
		const height = $recipes_slider.height();
		$("#recipes-modal").animate({  scrollTop: height + 'px' },1000);
	})

	const show_recipe = ($elem) => {
		if (!$('html').hasClass('uk-modal-page')) {
			$('#recipes_slider').html($recipe_slider_content.html());
			$('#recipes_slider li')
				.filter((i, li) => !~$.inArray(term, $(li).data('terms')))
				.remove();
			a2a.init();
			$('[data-clipboard-copy-link]').each(function () {
				$(this).on('click', function (e) {
					e.preventDefault();
					copyTextToClipboard($(this).data('link'))
						.then(e => {
							alert('Share link copied to clipboard')
						})
						.catch(e => {
							alert('Link could not be copied to clipboard')
						});
				})
			})
			if ($('#recipes_slider li').length === 1) {
				$('.recipes_slider_next').hide();
			}
			slider = UIkit.slider('#recipes_slider', { draggable: false });
			const target_slide = $elem.data('id');
			slider.index = $(`#recipes_slider [data-id="${target_slide}"]`).index();;
			slider.show();
			UIkit.modal('#recipes-modal').show();

			$('html').addClass('recipes-modal-open');
		}

		window.location.hash = '';

	};

	$('.recipe_filters a').on('click', function (e) {
		filter($(this));
	});

	$(window).on('hashchange', () => {
		filter($(`[href="${window.location.hash}"]`));
	})

	$('.recipe').on('click', function (e) {
		e.preventDefault();
		show_recipe($(this));
	});

	const $elem = $(`[href="${window.location.hash}"]`);
	if ($elem.data('filter')) {
		filter($elem);
	} else if ($elem.data('recipe')) {
		show_recipe($elem);
	}

});





jQuery(($) => {

	$('#XD-front-page__intro-video').on('playing', () => {
		setTimeout(() => {
			$('.tag_line').removeClass('animation');
		}, 1300);
	});

	$('#age_verify').on('click', (e) => {
		e.preventDefault();
		$('html').removeClass('not-verified');
		$.post('/wp-admin/admin-ajax.php', { action: 'is_verified' });
		$('#age_verification').fadeOut('slow', () => {
			$('#XD-front-page__intro-video').get(0).play();
		});
	});
	$('#age_not_verify').on('click', (e) => {
		e.preventDefault();
		$('.not-verified').fadeIn();
	});
});


jQuery(($) => {
	const newAlert = window.alert;
	window.alert = (msg) => {
		if (msg == 'No results found') {
			$('#wpsl-stores .results').html(`
					<ul>
						<li class="wpsl-no-results-msg">
						<span class="is-style-p2-sabon">
								 No results found. <br>
								<a href="/order-online/">Order online</a></span>
						</li>
					</ul>'`);
		} else {
			newAlert(msg);
		}
	}
});

jQuery(($) => {
	let onTimer = null;
	let offTimer = null;
	$('[data-menu-item-id]').on('mouseenter',
		function () {
			const _this = $(this);
			clearTimeout(onTimer);
			clearTimeout(offTimer);
			onTimer = setTimeout(() => {
				$(`[data-page-id="${$(_this).data('menu-item-id')}"]`)
					.addClass('active')
					.siblings().removeClass('active');
			}, 200);
		}).on('mouseleave',
			function () {
				clearTimeout(onTimer);
				clearTimeout(offTimer);
				offTimer = setTimeout(() => {
					$(`[data-page-id="0"]`)
						.addClass('active')
						.siblings().removeClass('active');
				}, 200);
			}
		);
});

let scrollTimeout;
let enableAnimationTimeout;

jQuery(($) => {

	const amimateSlides = () => {
		$('.wp-block-xd-ingredients-slider .uk-scrollspy-inview .uk-active video').each(function (i) {
		
			const $video = $(this);
			if ($video.data('scroll-played')) {
				return;
			}
			$video.data('scroll-played', true);
			setTimeout(() => {
				$video.get(0).play();
			}, 500 * i);
			clearTimeout(enableAnimationTimeout);
			enableAnimationTimeout = setTimeout(() => {
				$('video').data('scroll-played', false);
			}, 8000);
		});
	}

	$('.wp-block-xd-ingredients-slider li').each(function () {
		$(this).on('mouseenter', function () {
			$(this).find('video').prop('loop', true).get(0).play();
		});
		$(this).on('mouseleave', function () {
			const $video = $(this).find('video');
			$video.prop('loop', false);
			$video.one('ended', function () {
				$video.get(0).pause();
			});
		});

	});

	$(window).on('scroll', () => {
		clearTimeout(scrollTimeout);
		scrollTimeout = setTimeout(() => {
			amimateSlides();
		}, 50);
	});

	UIkit.util.on('[data-ingredients-slider]', 'itemshown', function () {
		$('video').data('scroll-played', false);
		amimateSlides();
	});

})



function fallbackCopyTextToClipboard(text) {
	var textArea = document.createElement("textarea");
	textArea.value = text;

	textArea.style.top = "0";
	textArea.style.left = "0";
	textArea.style.position = "fixed";

	document.body.appendChild(textArea);
	textArea.focus();
	textArea.select();

	let p = new Promise((resolve, reject) => {
		try {
			if (document.execCommand('copy')) {
				resolve();
			} else {
				console.log('err')
				reject();
			}
		} catch (err) {
			console.log(err)
			reject();
		}
	});
	document.body.removeChild(textArea);
	return p;
}
function copyTextToClipboard(text) {
	if (!navigator.clipboard) {
		return fallbackCopyTextToClipboard(text);
	}
	return navigator.clipboard.writeText(text);
}

